import logo from "../assets/main logo.png";

// Import brand icons as PNGs
import facebookIcon from "../assets/Fb logo.png";
import instagramIcon from "../assets/insta logo.png";
import whatsappIcon from "../assets/Wp logo.png";
import googleMapsIcon from "../assets/google map.png";

export default function Contact() {
    const socialLinks = [
        { href: "https://www.facebook.com/share/16Yk7vppga/", icon: facebookIcon, alt: "Facebook" },
        { href: "https://www.instagram.com/amantranaacaterers?igsh=bGluNmF2NGxrbXdk", icon: instagramIcon, alt: "Instagram" },
        { href: "https://wa.me/+919448268316", icon: whatsappIcon, alt: "WhatsApp" },
    ];

    return (
        <footer
            id="contact"
            className="relative py-20 px-6 md:px-20 text-[#1F2937] font-[Playfair_Display]"
            style={{ background: "#FFFFFF" }}
        >
            {/* Main Grid */}
            <div className="max-w-7xl mx-auto relative z-10 border-y border-[#D4AF37]/30 py-10">
                <div className="grid md:grid-cols-3 gap-12">

                    {/* Column 1 */}
                    <div className="px-4">
                        <h2 className="text-2xl text-[#D4AF37] mb-4 font-semibold">
                            AMANTRANAA CATERERS
                        </h2>
                        <p className="text-[#4B5563] leading-relaxed">
                            We do Catering for any Special Occasions like Marriage, Birthday & all types Family Functions.
                        </p>
                    </div>

                    {/* Column 2 */}
                    <div className="px-4">
                        <h3 className="text-xl text-[#D4AF37] mb-4 font-semibold">
                            Contact Info
                        </h3>

                        <div className="space-y-4 text-[#4B5563]">

                            {/* Address */}
                            <div className="flex items-center gap-3">
                                <a
                                    href="https://maps.google.com/?q=No.+3,+Gangamma+Garden,+Malgala,+Bengaluru,+Karnataka+560072"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={googleMapsIcon} alt="Google Maps" className="h-6 w-6" />
                                </a>
                                <span>
                                    No. 3, Gangamma Garden, Malgala, Bengaluru, Karnataka – 560072
                                </span>
                            </div>

                            {/* Phone Numbers */}
                            <div className="flex items-start gap-3">
                                <span className="text-[#D4AF37]">📞</span>
                                <div className="flex flex-col space-y-1">
                                    <a href="tel:+919448268316">+91 94482 68316</a>
                                    <a href="tel:+917259175190">+91 72591 75190</a>
                                    <a href="tel:+917760277802">+91 77602 77802</a>
                                    <a href="tel:+917019325009">+91 70193 25009</a>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="flex items-center gap-3">
                                <span className="text-[#D4AF37]">✉️</span>
                                <a
                                    href="mailto:orders@amantranaacaterers.com"
                                    className="hover:text-[#D4AF37] transition-colors"
                                >
                                    orders@amantranaacaterers.com
                                </a>
                            </div>

                            {/* Hours */}
                            <div className="flex items-center gap-3">
                                <span className="text-[#D4AF37]">⏰</span>
                                <span>Available 24/7</span>
                            </div>

                        </div>
                    </div>

                    {/* Column 3 */}
                    <div className="px-4">
                        <h3 className="text-xl text-[#D4AF37] mb-4 font-semibold">
                            Connect With Us
                        </h3>

                        <div className="flex space-x-6 mt-4 justify-start mb-6">
                            {socialLinks.map((link, idx) => (
                                <a
                                    key={idx}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transition-all duration-300 hover:scale-110"
                                >
                                    <img src={link.icon} alt={link.alt} className="h-8 w-8" />
                                </a>
                            ))}
                        </div>

                        {/* Google Map */}
                        <iframe
                            src="https://www.google.com/maps?q=No.+3,+Gangamma+Garden,+Malgala,+Bengaluru,+Karnataka+560072&output=embed"
                            width="100%"
                            height="150"
                            className="rounded-lg border border-[#D4AF37]/30"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Amantranaa Caterers Location"
                        ></iframe>
                    </div>

                </div>

                {/* Dividers */}
                <div className="hidden md:block absolute top-10 bottom-10 left-1/3 w-[1px] bg-gradient-to-b from-transparent via-[#D4AF37]/40 to-transparent"></div>
                <div className="hidden md:block absolute top-10 bottom-10 left-2/3 w-[1px] bg-gradient-to-b from-transparent via-[#D4AF37]/40 to-transparent"></div>
            </div>

            {/* Bottom */}
            <div className="mt-16 text-center space-y-3">
                <img
                    src={logo}
                    alt="Amantranaa Logo"
                    className="h-16 w-auto mx-auto opacity-90 hover:opacity-100 transition-all duration-300 drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]"
                />
                <p className="text-sm text-[#6B7280]">
                    © {new Date().getFullYear()} AMANTRANAA CATERERS. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}
